import { ContractEffects } from './contract.effects';

export const effects: any[] = [ContractEffects];

export * from './contract.effects';
